module.exports = __webpack_public_path__ + "img/J12328.7a2bbe5a.png";